export const getFontUrlName = function getFontUrlName(name){
  return name.split(' ').join('-');
}

export const getFontGoogleCodeName = function getFontGoogleCodeName(name) {
  return name.split(' ').join('+');
}

export const stripHTML = function stripHTML(str) {
  const cleanText = str.replace(/<\/?[^>]+(>|$)/g, "");
  return cleanText;
}

export const shortenDesc = function shortenDesc(text, numChars) {
  let trimmedText = text.substr(0, numChars).trim();
  // trimmedText = trimmedText.substr(0, Math.min(trimmedText.length, trimmedText.lastIndexOf(" ")));
  if (trimmedText.length < text.length) {
    trimmedText += '...';
  }
  return trimmedText;
};



// WEBPACK FOOTER //
// ./src/helpers/fonts.js